/**
 * Mock Airlines data.
 *
 * Logos are self-contained inline SVG data-URIs (a colored rounded badge with the
 * airline code) so the module needs no external image assets. Swap `logo` for a real
 * asset URL when integrating a real API.
 */

/**
 * Build a data-URI SVG badge for an airline logo placeholder.
 * @param {string} code Airline IATA code shown on the badge.
 * @param {string} bg   Background hex color.
 * @param {string} [fg] Foreground (text) hex color.
 * @returns {string} data:image/svg+xml URI
 */
const badge = (code, bg, fg = "#ffffff") => {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80"><rect width="80" height="80" rx="16" fill="${bg}"/><text x="50%" y="50%" dy="0.36em" text-anchor="middle" font-family="Arial, Helvetica, sans-serif" font-size="26" font-weight="700" fill="${fg}">${code}</text></svg>`;
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
};

/**
 * @type {import('../types').Airline[]}
 */
const airlines = [
  { name: "Emirates", code: "EK", logo: badge("EK", "#d71a21") },
  { name: "Flydubai", code: "FZ", logo: badge("FZ", "#003a70") },
  { name: "Flyadeal", code: "F3", logo: badge("F3", "#5a2d81") },
  { name: "Saudia", code: "SV", logo: badge("SV", "#00754a") },
  { name: "Qatar Airways", code: "QR", logo: badge("QR", "#5c0632") },
  { name: "Etihad Airways", code: "EY", logo: badge("EY", "#bd8b13") },
  { name: "Air Arabia", code: "G9", logo: badge("G9", "#e2001a") },
  { name: "Gulf Air", code: "GF", logo: badge("GF", "#b8860b") },
  { name: "Pakistan International Airlines", code: "PK", logo: badge("PK", "#005b41") },
  { name: "Turkish Airlines", code: "TK", logo: badge("TK", "#c8102e") },
];

export default airlines;
